/**
 * Percorsi delle route che devono essere chiamate anche lato server
 */
export const RoutePaths = {
  ['/utente/login']: '/utente/login',
  ['/utente/login/dipendenti']: '/utente/login/dipendenti',
  ['/utente/attivazione']: '/utente/attivazione',
  ['/utente/reimposta-password']: '/utente/reimposta-password',
  ['/utente/completa-profilo']: '/utente/completa-profilo',
  ['/admin/imposta-password']: '/admin/imposta-password',
  ['/admin/login']: '/admin/login',
  ['/pdnd/accertamenti-c020']: '/pdnd/accertamenti-c020'
};
